import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["heart-rate-drift"]!;

export function Body() {
  return (
    <>
      <p>
        Late in a marathon, many runners see the same thing on their watch: the heart rate keeps
        climbing while the pace stays the same or drops. A study of 82,303 marathon runners
        looked at how much this happens and what it means for your finishing time.
      </p>

      <h2>What the researchers did</h2>
      <p>
        The researchers compared heart rate and speed early in the race, between 5 and 10 km,
        with the same numbers between 35 and 40 km. If your heart rate rises relative to your
        speed, your body is working harder for the same pace. They called this decoupling.
      </p>

      <h2>What they found</h2>
      <p>
        On average, the ratio between heart rate and speed rose by 16 percent from the start to
        the end of the race, and it usually began around 25 km. About a third of the runners
        had little decoupling. They held a higher pace relative to their fitness and finished
        faster. Men decoupled more and earlier than women on average.
      </p>
      <p>
        Adding decoupling to the model improved its estimates of marathon times.
      </p>

      <h2>What it means for you</h2>
      <p>
        Some drift is normal, especially in heat or if you haven't had enough to drink or eat.
        A large change is worth investigating alongside pacing, weather, fuelling and
        measurement quality. It cannot be attributed to fitness alone.
      </p>
      <p>
        Start your long runs and races at a pace you can hold. On long runs, notice whether your
        heart rate creeps up in the last part while the pace stays the same, and compare it
        with similar runs in similar weather.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The study measured drift during the marathon itself, so it explains race results after
        the fact. It doesn't show whether drift in training predicts how you will race, or which
        type of training reduces it.
      </p>

      <h2>How we use it</h2>
      <p>
        Where suitable heart-rate and speed data is available, PX7 Training compares the relationship
        within long, steady runs. Similar routes and conditions make comparisons more useful.
        Drift is context for reviewing your training, not a threshold test or a standalone
        reason to increase your next session.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Smyth et al. (2022), Decoupling of internal and external workload during a marathon: an
          analysis of durability in 82,303 recreational runners.{" "}
          <a href="https://doi.org/10.1007/s40279-022-01680-5">Sports Medicine</a>.
        </li>
        <li>
          Smyth & Muniz-Pumares (2020), Calculation of critical speed from raw training data in
          recreational marathon runners.{" "}
          <a href="https://doi.org/10.1249/MSS.0000000000002412">Medicine & Science in Sports & Exercise</a>.
        </li>
      </ul>
    </>
  );
}
